import {Component, inject} from '@angular/core';
import {CommonTableConfig} from '@lib-ui/common-table/models/common-table-config.class';
import {PersonTableService} from './person-table.service';
import {LoaderComponent} from '@lib-ui/loader/loader.component';
import {CommonTableComponent} from '@lib-ui/common-table/ui/common-table.component';
import {ICommonTableAction, ICommonTableConfig} from '@lib-ui/common-table/models/common-table.interface';
import {MatDialog} from '@angular/material/dialog';
import {RowAction} from '@lib-ui/common-table/models/common-table.enum';
import {PersonEditorComponent} from '../../components/person-editor/person-editor.component';
import {AdvancedSearchComponent} from '@lib-ui/advanced-search/ui/advanced-search.component';
import {FilterConfig} from '@lib-ui/advanced-search/models/advanced-search.interface';
import {FormControl} from '@angular/forms';
import {GroupsSelectorService} from '@lib-services/groups-selector.service';
import {EnumService} from '@lib-services/enum.service';
import {Role} from '@libs-enums/role.enum';
import {filter, switchMap} from 'rxjs';
import {PersonService} from '@lib-services/person.service';
import {MessageService} from '@lib-services/message.service';

@Component({
    selector: 'app-person',
    standalone: true,
    imports: [
        CommonTableComponent,
        LoaderComponent,
        AdvancedSearchComponent,
    ],
    templateUrl: './person.component.html',
    styleUrl: './person.component.scss'
})
export class PersonComponent {
    protected personTableService = inject(PersonTableService);
    protected personService = inject(PersonService);
    protected messageService = inject(MessageService);
    protected dialog = inject(MatDialog);
    protected enumService = inject(EnumService);

    tableConfig: ICommonTableConfig = new CommonTableConfig( {
        columns: [
            { name: 'id', title: 'ИН' },
            { name: 'fullName', title: 'ФИО' },
            { name: 'role', title: 'Роль' },
            { name: 'groupName', title: 'Группа' },
        ],
        createButtonLabel: 'Новый пользователь',
        showCreateButton: true,
        withCheckboxes: true,
        rowActions: [RowAction.DELETE],
    });
    filterConfig: FilterConfig[] = [
        {
            type: 'input',
            label: 'ФИО',
            name: 'name'
        },
        {
            type: 'common-dropdown',
            label: 'Группа',
            name: 'group.id',
            commonDropdownConfig: {
                service: inject(GroupsSelectorService),
                formCtrl: new FormControl(),
            },
        },
        {
            type: 'dropdown',
            label: 'Роль',
            name: 'role',
            options: this.enumService.enumTranslateRoleToArrSelects(Role).filter(role => role.value !== Role.admin),
            defaultOption: Role.executor
        },
    ];

    applyAction(value: ICommonTableAction): void {
        if (value.action === RowAction.CLICK) {
            this.openDialog({ personId: Number(value.data[0]['id']) });
        }
        if (value.action === RowAction.CREATE) {
            this.openDialog({});
        }
        if (value.action === RowAction.DELETE) {
            const ids = value.data.map(el => Number(el['id']));
            this.deletePersons(ids);
        }
    }

    openDialog(data: { personId?: number }): void  {
        this.dialog.open(PersonEditorComponent, {
            width: '50%',
            height: 'auto',
            data: data,
            disableClose: true,
        }).afterClosed().subscribe({
            next: () => {
                this.personTableService.updateData(this.tableConfig);
            }
        });
    };

    applyFilters(filterData: Record<string, string | null>): void {
        this.tableConfig.filters = filterData;
        this.tableConfig.paginatorConfig.pageIndex = 0;
        this.personTableService.updateData(this.tableConfig);
    }

    deletePersons(ids: number[]): void {
        this.messageService.confirmMessage({
            title: 'Удаление контакт(ов)',
            text: 'Вы действительно хотите удалить выбранные контакты?',
            primaryText: 'Удалить',
            secondaryText: 'Отмена',
            showSecondaryButton: true,
        }).pipe(
            filter(result => result),
            switchMap(() => {
                return this.personService.deletePersons(ids);
            }),
        ).subscribe({
            next: () => {
                this.messageService.successMessage('Контакты успешно удалены');
                this.personTableService.updateData(this.tableConfig);
            },
            error: () => this.messageService.errorMessage('При удалении произошла ошибка')
        });
    }

}
